var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tsa-verifyCode",class:[{'is-border': _vm.border=== true, 'disabled': _vm.disabled===true}],on:{"click":_vm.countStart}},[_c('p',[_vm._v(_vm._s(_vm.codeMsg))])])}
var staticRenderFns = []

export { render, staticRenderFns }